/* eslint-disable camelcase */

export default {
	new_authorization_letter: '新增授权函',
	authorization_letter: '授权函',
	are_you_sure__to_void_letter_of_authorization: '确定要作废该授权函吗'
};
